import { Button } from '@ui-propulsion/react-components';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import { ctaTheme } from '../../utils/util';

export default function CtaButton({ cta, theme, styles, classNames }) {
  const [ctaThemeC, setCtaThemeC] = useState(theme);

  useEffect(() => {
    setCtaThemeC(ctaTheme(cta?.ctaTheme));
  }, [cta]);

  return cta.ctaStyle === 'Button' ? (
    <Button
      className={`${ctaThemeC ?? ''} ${classNames ?? ''}`}
      aria-label={cta.label}
      variant="tertiary"
      onClick={(e) => handleCTAClick(e, cta)}
      href={cta.link}
    >
      {cta.label}
    </Button>
  ) : (
    <Link
      href={cta?.link ?? ''}
      className={`${styles ?? ''}${classNames ?? ''}`}
    >
      {cta.label}
    </Link>
  );
}
